import PropTypes from 'prop-types'
import { Label } from '@components/ui/label'
import { cn } from 'lib/utils'

export const AdasFormLabel = ({
  children,
  className,
  error,
  required,
  // eslint-disable-next-line no-unused-vars
  sx,
  ...props
}) => (
  <Label className={cn('text-sm font-medium', error && 'text-error', className)} {...props}>
    {children}
    {required && <span className='text-error ml-1'>*</span>}
  </Label>
)

AdasFormLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  error: PropTypes.bool,
  required: PropTypes.bool
}
